// extracted by mini-css-extract-plugin
module.exports = {"tags":"styles-m__tags__1h2_c","tag":"styles-m__tag__2_xRf","tag-link":"styles-m__tag-link__32CFx"};